import React from 'react';

import AssetsSellingSignContainer from '../../../containers/assets-selling-sign-container';
import AppPageMain from '../../../modules/app-page/app-page--main';
import PageHeader from '../../../modules/page-header';

const AssetsSigningSalePage: React.FC = () => (
  <AppPageMain>
    <div className="container">
      <div className="row">
        <div className="col-19 col-lg-27 col-xl-35">
          <PageHeader
            items={[
              { link: '/assets', title: 'Активы' },
              { link: '#', title: 'Денежные требования' },
            ]}
            iconType="assets"
          />
        </div>
      </div>
      <div className="row">
        <div className="col-19 col-lg-27 col-xl-35">
          <AssetsSellingSignContainer />
        </div>
      </div>
    </div>
  </AppPageMain>
);

export default AssetsSigningSalePage;
